import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCustomSelectValue = styled(Typography)`
  color: #2f2f2f;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;

export const StyledNullComponent = styled('div')`
  border: 1px solid #b6bbb9;
  border-radius: 8px;
  width: 100%;
  min-width: 90px;
  height: 40px;
  padding: 10px;
  background-color: #fff;
  cursor: pointer;

  color: #38414f;
  font-family: Poppins;
  font-size: 13px;
  font-style: italic;
  font-weight: 300;
  line-height: 32px;
  letter-spacing: 0.39px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;
